
import { format } from 'date-fns';
import { useEffect, useState } from 'react'
import useWebData from '../../hooks/useWebData';
import { bookingsStatusColorCode } from '../../utils/statusColor';
import { calulatedDiscountValue } from '../../utils/summaryCalculation';
import { iconValues } from '../../utils/iconValues';

type Props = {
    reservationDetailsOfBookingNumber: any;
}

const ReservationDetails = ({ reservationDetailsOfBookingNumber }: Props) => {
    const { webData }: any = useWebData();
    const [statusBg, setStatusBg] = useState<string>("");
    const [statusTextColor, setStatusTextColor] = useState<string>("");
    const [updatedTaxList, setUpdatedTaxList] = useState<any[]>([]);
    const [totalAfterDiscount, setTotalAfterDiscount] = useState<number>(0.0);
    const [securityDepositAmount, setSecurityDepositAmount] = useState<number>(0.0);
    const [appliedDiscountList, setAppliedDiscountList] = useState<any[]>([
        {
            id: 0,
            discountId: 0,
            discountDefinition: "",
            discountType: "Percentage",
            discountAmount: 0.00,
            discount: 0.00,
            manualDiscount: false,
            discountApplied: false
        },
        {
            id: 0,
            discountId: 0,
            discountDefinition: "Manual Discount",
            discountType: "Amount",
            discountAmount: 0.00,
            discount: 0.00,
            manualDiscount: true,
            discountApplied: false
        }
    ]);

    useEffect(() => {
        let color = {
            colorBg: "#000000",
            colorText: "#000000"
        };

        color = bookingsStatusColorCode?.find((color: any) => color?.label === reservationDetailsOfBookingNumber?.status.trim()?.toLowerCase()) || {
            colorBg: "#000000",
            colorText: "#000000"
        };

        setStatusBg(color.colorBg);
        setStatusTextColor(color.colorText);

        setSecurityDepositAmount(reservationDetailsOfBookingNumber?.securityDepositAmount - reservationDetailsOfBookingNumber?.securityDepositAmountPaid > 0 ? reservationDetailsOfBookingNumber?.securityDepositAmount - reservationDetailsOfBookingNumber?.securityDepositAmountPaid : 0);

        const addedTaxList = [];
        if (reservationDetailsOfBookingNumber?.mandatoryAdditionalChargesAmount && reservationDetailsOfBookingNumber?.mandatoryAdditionalChargesAmount > 0) {
            addedTaxList.push({
                taxName: "Additional Charge Fee",
                taxAmount: reservationDetailsOfBookingNumber?.mandatoryAdditionalChargesAmount ?? "",
                taxType: "Amount",
                selectionType: "One Time",
                basePrice: reservationDetailsOfBookingNumber?.mandatoryAdditionalChargesAmount
            });
        }

        if (reservationDetailsOfBookingNumber?.locationFeeAmount && reservationDetailsOfBookingNumber?.locationFeeAmount > 0) {
            addedTaxList.push({
                taxName: "Location Tax Fee",
                taxAmount: reservationDetailsOfBookingNumber?.locationFeePercentage ?? "",
                taxType: "Percent",
                selectionType: "One Time",
                basePrice: reservationDetailsOfBookingNumber?.locationFeeAmount
            });
        }

        if (reservationDetailsOfBookingNumber?.taxAmount && reservationDetailsOfBookingNumber?.taxAmount > 0) {
            addedTaxList.push({
                taxName: "Tax Fee",
                taxAmount: reservationDetailsOfBookingNumber?.taxPercentage ?? "",
                taxType: "Percent",
                selectionType: "One Time",
                basePrice: reservationDetailsOfBookingNumber?.taxAmount
            });
        }

        if (reservationDetailsOfBookingNumber?.governmentTaxAmount && reservationDetailsOfBookingNumber?.governmentTaxAmount > 0) {
            addedTaxList.push({
                taxName: "Government Tax Fee",
                taxAmount: reservationDetailsOfBookingNumber?.governmentTaxPercentage ?? "",
                taxType: "Percent",
                selectionType: "One Time",
                basePrice: reservationDetailsOfBookingNumber?.governmentTaxAmount
            });
        }

        setUpdatedTaxList(addedTaxList);


        let basePrice = 0;
        let totalOfSelectedVehicleClass = 0;
        if (reservationDetailsOfBookingNumber.totalMonths > 0) {
            basePrice += (reservationDetailsOfBookingNumber.totalMonths * reservationDetailsOfBookingNumber.monthlyRate);
        }

        if (reservationDetailsOfBookingNumber.totalWeeks > 0) {
            basePrice += (reservationDetailsOfBookingNumber.totalWeeks * reservationDetailsOfBookingNumber.weeklyRate);
        }

        if (reservationDetailsOfBookingNumber.totalDays > 0) {
            basePrice += (reservationDetailsOfBookingNumber.totalDays * reservationDetailsOfBookingNumber.dailyRate);
        }

        if (reservationDetailsOfBookingNumber.totalHours > 0) {
            basePrice += (reservationDetailsOfBookingNumber.totalHours * reservationDetailsOfBookingNumber.hourlyRate);
        }

        totalOfSelectedVehicleClass = basePrice;

        reservationDetailsOfBookingNumber?.reservationDiscountsForAgreement?.forEach((item: any) => {
            let discountPrice = 0;
            if (item?.discountType === "Amount") {
                discountPrice = item?.discountAmount ?? 0;
            } else {
                discountPrice = ((basePrice * (item?.discountAmount || 0)) / 100) || 0;
            }

            basePrice -= discountPrice;
        });

        setTotalAfterDiscount(basePrice);

        const couponDiscount = reservationDetailsOfBookingNumber?.reservationDiscountsForAgreement?.find((item: any) => !item?.manualDiscount);
        const manualDiscount = reservationDetailsOfBookingNumber?.reservationDiscountsForAgreement?.find((item: any) => item?.manualDiscount);

        let couponDiscountValue = 0.00;
        if (couponDiscount) {
            couponDiscountValue = calulatedDiscountValue(couponDiscount?.discountAmount, couponDiscount?.discountType, totalOfSelectedVehicleClass);
        }

        let manualDiscountValue = 0.00;
        if (manualDiscount) {
            manualDiscountValue = calulatedDiscountValue(manualDiscount?.discountAmount, manualDiscount?.discountType, totalOfSelectedVehicleClass);
        }

        setAppliedDiscountList([
            {
                id: couponDiscount ? couponDiscount?.id : 0,
                discountId: couponDiscount ? couponDiscount?.discountId : 0,
                discountDefinition: couponDiscount ? couponDiscount?.discountDefinition : 0,
                discountType: couponDiscount ? couponDiscount?.discountType : "Percentage",
                discountAmount: couponDiscount ? couponDiscount?.discountAmount : 0.00,
                discount: couponDiscountValue,
                manualDiscount: false,
                discountApplied: couponDiscount ? true : false
            },
            {
                id: manualDiscount ? manualDiscount?.id : 0,
                discountId: 0,
                discountDefinition: manualDiscount ? manualDiscount?.discountDefinition : 0,
                discountType: manualDiscount ? manualDiscount?.discountType : "Amount",
                discountAmount: manualDiscount ? manualDiscount?.discountAmount : 0.00,
                discount: manualDiscountValue,
                manualDiscount: true,
                discountApplied: manualDiscount ? true : false
            }
        ]);


    }, [reservationDetailsOfBookingNumber])

    return (
        <div className="px-4 py-6 md:px-12 lg:px-32 xl:px-48 2xl:px-60">
            {/* Status */}
            <div className="flex justify-center mb-4">
                <span
                    className={`text-xs font-bold px-3 py-1 rounded-md ${statusBg} ${statusTextColor} border-[#E4E7EC]`}
                >
                    {reservationDetailsOfBookingNumber?.status}
                </span>
            </div>

            {/* Header */}
            <div className="bg-white rounded-lg shadow-md p-4 mb-6 border border-gray-200">
                <div className="flex justify-between items-center mb-2">
                    <h1 className="text-base font-bold">
                        Booking #{reservationDetailsOfBookingNumber?.bookingNumber}
                    </h1>
                    <p className="text-sm text-gray-600">
                        {reservationDetailsOfBookingNumber?.firstName} {reservationDetailsOfBookingNumber?.lastName}
                    </p>
                </div>
                <hr className="border-gray-300" />

                {/* Date & Time */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4 text-sm">
                    <div className='space-y-2'>
                        <p className="font-semibold">Pickup</p>
                        <p className="text-gray-700">{format(new Date(reservationDetailsOfBookingNumber?.pickupDate), "MM/dd/yyyy")} at {reservationDetailsOfBookingNumber?.pickupTime}</p>
                        <p className="text-gray-600 text-xs">{reservationDetailsOfBookingNumber?.pickupLocationName}</p>
                        <p className="text-gray-600 text-xs">{reservationDetailsOfBookingNumber?.pickupLocationAddress}</p>
                    </div>
                    <div className='space-y-2'>
                        <p className="font-semibold">Return</p>
                        <p className="text-gray-700">{format(new Date(reservationDetailsOfBookingNumber?.returnDate), "MM/dd/yyyy")} at {reservationDetailsOfBookingNumber?.returnTime}</p>
                        <p className="text-gray-600 text-xs">{reservationDetailsOfBookingNumber?.returnLocationName}</p>
                        <p className="text-gray-600 text-xs">{reservationDetailsOfBookingNumber?.returnLocationAddress}</p>
                    </div>
                </div>
            </div>

            {/* Vehicle Info */}
            <div className="bg-white rounded-lg shadow-md p-4 mb-6 border border-gray-200">
                <h2 className="text-sm font-bold mb-2">Vehicle</h2>
                <hr className="border-gray-300 mb-4" />

                <div className="flex flex-col md:flex-row gap-4">
                    <img
                        src={
                            reservationDetailsOfBookingNumber?.vehicleClassImage}
                        alt="Vehicle"
                        className="w-full md:w-[230px] rounded-md object-cover"
                    />

                    <div className="flex-1 space-y-1">
                        <h5 className="font-semibold text-gray-800">{reservationDetailsOfBookingNumber?.vehicleClassLabel}</h5>
                        {
                            reservationDetailsOfBookingNumber.features
                                ?.sort((a: any, b: any) => a.order - b.order)
                                ?.map((feature: any, i: number) => {
                                    const iconData = iconValues?.find((icon) => icon.value === feature?.icon);
                                    return (
                                        <div
                                            key={i}
                                            className={`flex items-center gap-1 text-xs text-black-rgba`}
                                        >
                                            {
                                                iconData && (
                                                    <span className={`material-symbols-outlined text-[16px]`}>{iconData.icon}</span>
                                                )
                                            }
                                            <span>{feature?.websiteLabel}</span>
                                        </div>
                                    )
                                })
                        }
                    </div>
                </div>

                <div
                    className="mt-4 px-4 py-2 border rounded-md bg-gray-100 text-right"
                    style={{ borderColor: webData?.websiteHeaderColor }}
                >
                    <p className="text-sm font-bold">${parseFloat(reservationDetailsOfBookingNumber?.dailyRate).toFixed(2)} / Day</p>
                    <p className="text-xs text-gray-600">Excl. taxes & insurance(s)</p>
                </div>
            </div>

            {/* Amount Details */}
            <div className="bg-white rounded-lg shadow-md p-4 border border-gray-200">
                <h2 className="text-sm font-bold mb-2">Payment Summary</h2>
                <hr className="border-gray-300 mb-4" />

                <div className="flex flex-col gap-1.5">
                    {
                        reservationDetailsOfBookingNumber?.totalMonths !== 0 && (
                            <div className="flex justify-between items-start w-full">
                                <span className={`text-xs font-medium break-all flex-1 text-left text-[#1D2939]`}>{reservationDetailsOfBookingNumber?.totalMonths}x Months</span>
                                <span className={`text-xs font-medium break-all flex-1 text-right text-[#1D2939]`}> ${reservationDetailsOfBookingNumber?.monthlyRate?.toFixed(2)}</span>
                                <span className={`text-xs font-medium break-all flex-1 text-right text-[#1D2939]`}>${(reservationDetailsOfBookingNumber?.totalMonths * reservationDetailsOfBookingNumber?.monthlyRate)?.toFixed(2)}</span>
                            </div>
                        )
                    }

                    {
                        reservationDetailsOfBookingNumber?.totalWeeks !== 0 && (
                            <div className="flex justify-between items-start w-full">
                                <span className={`text-xs font-medium break-all flex-1 text-left text-[#1D2939]`}>{reservationDetailsOfBookingNumber?.totalWeeks}x Weeks</span>
                                <span className={`text-xs font-medium break-all flex-1 text-right text-[#1D2939]`}>${reservationDetailsOfBookingNumber?.weeklyRate?.toFixed(2)}</span>
                                <span className={`text-xs font-medium break-all flex-1 text-right text-[#1D2939]`}>${(reservationDetailsOfBookingNumber?.totalWeeks * reservationDetailsOfBookingNumber?.weeklyRate)?.toFixed(2)}</span>
                            </div>
                        )
                    }

                    {
                        reservationDetailsOfBookingNumber?.totalDays !== 0 && (
                            <div className="flex justify-between items-start w-full">
                                <span className={`text-xs font-medium break-all flex-1 text-left text-[#1D2939]`}>{reservationDetailsOfBookingNumber?.totalDays}x Days</span>
                                <span className={`text-xs font-medium break-all flex-1 text-right text-[#1D2939]`}>${reservationDetailsOfBookingNumber?.dailyRate?.toFixed(2)}</span>
                                <span className={`text-xs font-medium break-all flex-1 text-right text-[#1D2939]`}>${(reservationDetailsOfBookingNumber?.totalDays * reservationDetailsOfBookingNumber?.dailyRate)?.toFixed(2)}</span>
                            </div>
                        )
                    }

                    {
                        reservationDetailsOfBookingNumber?.totalHours !== 0 && (
                            <div className="flex justify-between items-start w-full">
                                <span className={`text-xs font-medium break-all flex-1 text-left text-[#1D2939]`}>{reservationDetailsOfBookingNumber?.totalHours}x Hours</span>
                                <span className={`text-xs font-medium break-all flex-1  text-right text-[#1D2939]`}>${reservationDetailsOfBookingNumber?.hourlyRate?.toFixed(2)}</span>
                                <span className={`text-xs font-medium break-all flex-1 text-right text-[#1D2939]`}>${(reservationDetailsOfBookingNumber?.totalHours * reservationDetailsOfBookingNumber?.hourlyRate)?.toFixed(2)}</span>
                            </div>
                        )
                    }

                    <hr className={`w-full bg-[#E4E7EC]`} />

                    {
                        appliedDiscountList
                            ?.filter((item: any) => item?.discountApplied)
                            ?.map((item: any, index: number) => {
                                return (
                                    <div key={index} className="flex justify-between items-center">
                                        <span className={`text-xs font-medium break-all flex-1 text-left text-black-rgba`}>{item?.discountDefinition}:</span>
                                        <span className={`text-xs font-medium break-all w-[30%] text-right text-black`}>-${parseFloat(item?.discount)?.toFixed(2)}</span>
                                    </div>
                                )
                            })
                    }

                    <div className="flex justify-between items-start">
                        <span className={`text-xs font-medium break-all flex-1 text-left text-black-rgba`}></span>
                        <span className={`text-xs font-medium break-all w-[30%] text-right text-[#1D2939]`}>${totalAfterDiscount?.toFixed(2)}</span>
                    </div>

                    {
                        reservationDetailsOfBookingNumber?.chargeFuleToClient && reservationDetailsOfBookingNumber?.fuelLevelCharge > 0 && (
                            <div>
                                <span className={`text-sm font-bold text-[#1D2939]`}>Equipment & Services</span>
                                <div className="flex justify-between items-start mb-2">
                                    <span className={`text-xs font-medium break-all flex-1 text-left text-black-rgba`}>Charge For Fuel {reservationDetailsOfBookingNumber?.fuelLevelCharge || 0}x:</span>
                                    <span className={`text-xs font-medium break-all w-[30%] text-right text-[#1D2939]`}>${reservationDetailsOfBookingNumber?.fuelCharge?.toFixed(2)}</span>
                                </div>
                            </div>
                        )
                    }

                    {
                        reservationDetailsOfBookingNumber?.additionalCategoryForAgreement?.map((item: any, j: number) => {
                            return (
                                <div key={j}>
                                    <span className={`text-sm font-bold text-[#1D2939]`}>{item?.categoryName}</span>

                                    {
                                        item?.additionalChargesForAgreement?.map((value: any, i: number) => {
                                            return (
                                                <div key={i} className="flex justify-between items-center mb-2">
                                                    <span className={`text-xs font-medium break-all flex-1 text-left text-black-rgba`}>{value?.name} {value?.quantity > 1 ? value?.quantity + "x " : ''}:</span>
                                                    <span className={`text-xs font-medium break-all w-[30%] text-right text-[#1D2939]`}>${(value?.quantity * value?.basePrice)?.toFixed(2)}</span>
                                                </div>
                                            )

                                        })
                                    }
                                </div>
                            )
                        })
                    }

                    {
                        updatedTaxList?.length > 0 && (
                            <div>
                                <span className={`text-xs font-bold text-black`}>Miscellaneous</span>
                                {
                                    updatedTaxList?.map((item: any, index: number) => (
                                        <div
                                            key={index}
                                            className="flex justify-between items-center"
                                        >
                                            <span className={`text-xs font-medium break-all flex-1 text-left text-black-rgba`}>{item?.taxName}{`${item?.taxType === "Percent" ? ` (${item?.taxAmount}%)` : ""}`}:</span>
                                            <span className={`text-xs font-medium break-all w-[30%] text-right text-black`}> ${parseFloat(item?.basePrice)?.toFixed(2)}</span>
                                        </div>
                                    ))
                                }
                            </div>
                        )
                    }
                </div>


                <hr className={`w-full !mt-2 bg-[#E4E7EC]`} />

                <div className={`flex justify-between items-center py-2`}>
                    <span className={`text-sm font-bold text-black-rgba`}>Total {(reservationDetailsOfBookingNumber?.status === "Cancelled" || reservationDetailsOfBookingNumber?.status === "Cancelled Paid") && " (Cancellation Fee)"}</span>
                    <span className={`text-sm font-bold text-[#1D2939]`}>${reservationDetailsOfBookingNumber?.totalPrice?.toFixed(2)}</span>
                </div>

                {(!reservationDetailsOfBookingNumber?.securityDepositPaid && securityDepositAmount > 0)
                    && (
                        <>
                            <hr className={`w-full bg-[#E4E7EC]`} />

                            <div className={`flex justify-between items-center py-4`}>
                                <span className={`text-sm font-bold text-black-rgba`}>Security Deposit</span>
                                <span className={`text-sm font-bold ${!reservationDetailsOfBookingNumber?.securityDepositPaid ? "text-red-500" : "text-[#1D2939]"}`}>${securityDepositAmount ? securityDepositAmount?.toFixed(2) : 0.00}</span>
                            </div>
                        </>
                    )
                }

                {
                    reservationDetailsOfBookingNumber?.reservationPaymentsForAgreement
                        ?.filter((item: any) => item?.paymentType === "Payment")
                        ?.length > 0 && (
                        <>
                            <hr className={`w-full bg-[#E4E7EC]`} />

                            <div className={`pt-2`}>
                                <span className={`text-sm font-bold text-[#1D2939]`}>Payments</span>
                            </div>

                            <div className="flex flex-col">
                                {
                                    reservationDetailsOfBookingNumber?.reservationPaymentsForAgreement
                                        ?.filter((item: any) => item?.paymentType === "Payment")
                                        ?.map((item: any, index: number) => {
                                            let subHeaderTest = "";

                                            if (item?.cClastFourDigit) {
                                                subHeaderTest = `${item?.cClastFourDigit || ""} ${item?.brand} - ${item?.reference || ""}`;
                                            } else if (item?.brand) {
                                                subHeaderTest = `${item?.brand || ""} - ${item?.reference || ""}`;
                                            } else {
                                                subHeaderTest = `${item?.reference || ""}`;
                                            }

                                            return (
                                                <div key={index} className="flex justify-between items-center">
                                                    <span className={`text-xs font-medium break-all flex-1 text-left text-black-rgba`}>{subHeaderTest}:</span>
                                                    <span className={`text-xs font-medium break-all w-[30%] text-right text-[#1D2939]`}>${parseFloat(item?.amount)?.toFixed(2)}</span>
                                                </div>
                                            )
                                        })
                                }
                            </div>
                        </>
                    )
                }

                {
                    reservationDetailsOfBookingNumber?.reservationPaymentsForAgreement
                        ?.filter((item: any) => item?.paymentType === "Security Deposit")
                        ?.length > 0 && (
                        <>
                            <hr className={`w-full bg-[#E4E7EC]`} />

                            <div className={`pt-2`}>
                                <span className={`text-sm font-bold text-[#1D2939]`}>Security Deposits</span>
                            </div>

                            <div className="flex flex-col">
                                {
                                    reservationDetailsOfBookingNumber?.reservationPaymentsForAgreement
                                        ?.filter((item: any) => item?.paymentType === "Security Deposit")
                                        ?.map((item: any, index: number) => {
                                            let subHeaderTest = "";

                                            if (item?.cClastFourDigit) {
                                                subHeaderTest = `${item?.cClastFourDigit || ""} ${item?.brand} - ${item?.reference || ""} (Security Deposit)`;
                                            } else if (item?.brand) {
                                                subHeaderTest = `${item?.brand || ""} - ${item?.reference || ""} (Security Deposit)`;
                                            } else {
                                                subHeaderTest = `${item?.reference || ""} (Security Deposit)`;
                                            }

                                            return (
                                                <div key={index} className="flex justify-between items-center mb-2">
                                                    <span className={`text-xs font-medium break-all flex-1 text-left text-black-rgba`}>{subHeaderTest}:</span>
                                                    <span className={`text-xs font-medium break-all w-[30%] text-right text-[#1D2939]`}>${parseFloat(item?.amount)?.toFixed(2)}</span>
                                                </div>
                                            )
                                        })
                                }
                            </div>
                        </>
                    )
                }

                {
                    reservationDetailsOfBookingNumber?.reservationRefundsForAgreement?.length > 0 && (
                        <>
                            <hr className={`w-full bg-[#E4E7EC]`} />

                            <div className={`pt-2`}>
                                <span className={`text-sm font-bold text-[#1D2939]`}>Refunds</span>
                            </div>

                            <div className="flex flex-col">
                                {
                                    reservationDetailsOfBookingNumber?.reservationRefundsForAgreement?.map((item: any, index: number) => {
                                        const isSecurityDepositRefund = item?.refundType === "Security Deposit";
                                        let subHeaderTest = "";

                                        if (item?.cClastFourDigit) {
                                            subHeaderTest = `${item?.cClastFourDigit || ""} ${item?.brand || ""} - ${item?.reference || ""} ${isSecurityDepositRefund ? "(Security Deposit)" : ""}`;
                                        } else if (item?.brand) {
                                            subHeaderTest = `${item?.brand || ""} - ${item?.reference || ""} ${isSecurityDepositRefund ? "(Security Deposit)" : ""}`;
                                        } else {
                                            subHeaderTest = `${item?.reference || ""} ${isSecurityDepositRefund ? "(Security Deposit)" : ""}`;
                                        }

                                        return (
                                            <div key={index} className="flex justify-between items-center mb-2">
                                                <span className={`text-xs font-medium break-all flex-1 text-left text-black-rgba`}>{subHeaderTest}:</span>
                                                <span className={`text-xs font-medium break-all w-[30%] text-right text-[#1D2939]`}>${Math.abs(parseFloat(item?.amount))?.toFixed(2)}</span>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        </>
                    )
                }

                <hr className={`w-full bg-[#E4E7EC]`} />

                <div className={`flex justify-between items-center py-2`}>
                    <span className={`text-sm font-bold text-black-rgba`}>Outstanding Balance</span>

                    <span className={`text-sm font-bold text-[#1D2939]`}>${reservationDetailsOfBookingNumber?.outstandingBalance?.toFixed(2) ?? 0.00}</span>
                </div>
            </div>
        </div>

    )
}

export default ReservationDetails